import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const AppWrapper = styled(Flexbox)`
  width: 100%;
  height: 100%;
`;

export const NavbarWrapper = styled(Flexbox)`
  width: 100%;
  flex-basis: 55px;
`;
